module.exports = __webpack_public_path__ + "media/images/performance-index-continuum-full-d464e4fbb184ce4654734d449c601114.jpg";